export default {
  data() {
    return { maxLoan: localStorage.getItem('maxLoan') };
  },
  id: '02c38c3669',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page ios-home" data-name="approval">\r\n      <div class="page-content ios-home__content">\r\n        <div class="ios-home__hero">\r\n          <div class="ios-home__glow"></div>\r\n          <div class="confetti" aria-hidden="true">\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n            <div class="confetti-piece"></div>\r\n          </div>\r\n\r\n          <div class="text-align-center">\r\n            <div class="ios-home__hero-icon">\r\n              <img src="images/success.png" alt="" class="ios-home__icon" height="96">\r\n            </div>\r\n            <h2 class="ios-home__title">Congratulations!</h2>\r\n            <p class="ios-home__subtitle">\r\n              You\'re approved for a credit limit of<br />\r\n              <span class="ios-home__max-loan">\u20B9 ';
      r += c(ctx_1.maxLoan, ctx_1);
      r += '</span>\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n        <div class="ios-home__bottom">\r\n          <div class="list no-hairlines">\r\n            <ul>\r\n              <li>\r\n                <a href="/apply/" class="button button-large button-fill text-color-white text-align-center margin-bottom button-shine ios-home__cta">\r\n                  Get Money Now\r\n                </a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n\r\n          <div class="ios-home__rbi">\r\n            <div class="card ios-home__rbi-card">\r\n              <div class="card-content ios-home__rbi-content">\r\n                <img src="images/rbi.png" alt="RBI logo" height="48" class="ios-home__rbi-logo">\r\n                <div>\r\n                  <div class="ios-home__rbi-title">From RBI Registered NBFC</div>\r\n                  <div class="ios-home__rbi-subtitle">Regulated by the Reserve Bank of India</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class="ios-home__note display-flex flex-direction-row">\r\n            <img src="images/shield.png" alt="" height="24" class="ios-home__note-icon">\r\n            <span class="ios-home__note-text f-12">Your information is protected with the latest encryption technology. We prioritize your privacy and security.</span>\r\n          </div>\r\n        </div>\r\n      </div>  \r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
  /* iOS-styled Home (Primary: #F24A1C, BG: #1d1d1d) */
  .ios-home,
  .ios-home .page-content {
    background: #1d1d1d;
    color: #ffffff;
  }

  .ios-home__content {
    padding-top: calc(var(--f7-safe-area-top) + 16px);
    padding-bottom: calc(var(--f7-safe-area-bottom) + 20px);
  }

  .ios-home__hero {
    position: relative;
    top: -20px;
    padding: 84px 20px 30px;
    overflow: hidden;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
    background:
      radial-gradient(80% 60% at 50% 0%, rgba(242, 74, 28, 0.38) 0%, rgba(29, 29, 29, 0) 70%),
      linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.00) 65%);
  }

  /* Confetti should float above the hero without affecting layout */
  .ios-home__hero .confetti {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 2;
  }

  .ios-home__hero .text-align-center {
    position: relative;
    z-index: 3;
  }

  .ios-home__glow {
    position: absolute;
    inset: -40% -30% auto;
    height: 240px;
    background: radial-gradient(circle at 50% 50%, rgba(242, 74, 28, 0.35) 0%, rgba(242, 74, 28, 0) 70%);
    filter: blur(10px);
    pointer-events: none;
  }

  .ios-home__hero-icon {
    margin-top: 25px;
    margin-bottom: 10px;
  }

  .ios-home__icon {
    border-radius: 24px;
    filter: drop-shadow(0 14px 28px rgba(0, 0, 0, 0.45));
  }

  .ios-home__title {
    margin: 6px 0 6px;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .ios-home__subtitle {
    margin: 0;
    font-size: 15px;
    opacity: 0.92;
  }

  .ios-home__max-loan {
    color: #F24A1C;
    font-weight: 800;
    font-size: 24px;
  }

  .ios-home__bottom {
    padding: 18px 20px 0;
  }

  .ios-home__cta {
    width: 100%;
    height: 54px;
    line-height: 54px;
    padding: 0 18px;
    border-radius: 16px;
    background: linear-gradient(135deg, #F24A1C 0%, #FF6A3B 100%);
    box-shadow:
      0 14px 30px rgba(242, 74, 28, 0.30),
      0 8px 16px rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.10);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* Make existing shine effect feel more iOS-like */
  .ios-home__cta.button-shine {
    position: relative;
    overflow: hidden;
  }

  .ios-home__cta.button-shine::after {
    content: '';
    position: absolute;
    top: -20%;
    left: -40%;
    width: 40%;
    height: 140%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.18) 50%, rgba(255, 255, 255, 0) 100%);
    transform: skewX(-18deg);
    animation: ios-home-shine 2.6s ease-in-out infinite;
  }

  @keyframes ios-home-shine {
    0% { transform: translateX(-140%) skewX(-18deg); opacity: 0; }
    25% { opacity: 1; }
    55% { opacity: 0.85; }
    100% { transform: translateX(420%) skewX(-18deg); opacity: 0; }
  }

  .ios-home__note {
    margin-top: 18px;
    gap: 10px;
    padding: 12px 12px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .ios-home__note-icon {
    filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.35));
    opacity: 0.95;
  }

  .ios-home__note-text {
    line-height: 1.35;
    opacity: 0.92;
  }

  .ios-home__rbi {
    margin-top: 10px;
  }

  .ios-home__rbi-card {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 18px;
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    margin: 0;
  }

  .ios-home__rbi-content {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
  }

  .ios-home__rbi-logo {
    flex: 0 0 auto;
    filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.35));
  }

  .ios-home__rbi-title {
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.01em;
  }

  .ios-home__rbi-subtitle {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.82);
    margin-top: 2px;
  }
`,
  styleScoped: false
};